"use client"

// SWEEPSTAKES (DEV-10678). The campaign's question, appended after the CMS
// items. `builder.tsx` adds the same question to the FAQ JSON-LD.
import {
  sweepstakesFaqItem,
  type SweepstakesState,
} from "@local/offer/src/lib/const/sweepstakes"
import { FaqItem } from "./FaqItem"

interface SweepstakesFaqItemProps {
  market: string
  /** Channel slug; "store" takes the store opening clause. */
  channel: string
  /** State the schedule resolved to, server-side. */
  scheduled: SweepstakesState
  /** Position after the CMS items, so it never becomes the auto-opened first. */
  index: number
  textColor?: string
}

export const SweepstakesFaqItem = ({
  market,
  channel,
  scheduled,
  index,
  textColor,
}: SweepstakesFaqItemProps) => {
  const item = sweepstakesFaqItem(market, channel, scheduled)

  if (!item) {
    return null
  }

  return <FaqItem itemData={item} index={index} textColor={textColor} />
}
